import React from "react";
import { Card, Typography } from "antd";
import PropTypes from "prop-types";
import { QrcodeOutlined } from "@ant-design/icons";

const CreditCard = (props) => {
    return (
        <Card className="credit-card" bordered={false}>
           { props.cardType === 'virtual' &&
                <Typography.Title level={4}>
                    <QrcodeOutlined />
                </Typography.Title>
            }
            <Typography.Title level={5}>{props.name}</Typography.Title>
            <Typography.Title level={5}>
                {(props.number && props.number.length > 0) ? props.number : "XXXX XXXX XXXX XXXX"}
            </Typography.Title>
        </Card>
    );
};

CreditCard.defaultProps = {
    name: "",
    number: "",
    cardType: "",
};

CreditCard.propTypes = {
    name: PropTypes.string,
    number: PropTypes.string,
    cardType: PropTypes.string
};

export { CreditCard }